import { QueryClient } from "@tanstack/react-query";

// Some browsers report navigator.onLine === false while online (VPNs, security agents); the
// default "online" mode then pauses every request forever, leaving a blank screen.
const QUERY_NETWORK_MODE = "offlineFirst";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: true,
      networkMode: QUERY_NETWORK_MODE,
    },
    mutations: {
      networkMode: QUERY_NETWORK_MODE,
    },
  },
});
